import { getLabelChipStyles } from '@/utils/LabelColors'
import type { ContentLabel } from '@/types/Label.types'
import './label-chips.css'

interface LabelChipsProps {
	labels: ContentLabel[]
	maxVisible?: number
	compact?: boolean
}

export function LabelChips({ labels, maxVisible = 2, compact = false }: LabelChipsProps) {
	if (!labels || labels.length === 0) return null

	if (compact) {
		return (
			<div className="label-chips label-chips-compact">
				{labels.map((label) => (
					<span
						key={label.id}
						className="label-chip-dot"
						style={{ backgroundColor: label.color }}
						role="img"
						aria-label={label.name}
						title={label.name}
					/>
				))}
			</div>
		)
	}

	const visible = labels.slice(0, maxVisible)
	const overflow = labels.length - maxVisible

	return (
		<div className="label-chips">
			{visible.map((label) => (
				<span
					key={label.id}
					className="label-chip"
					style={getLabelChipStyles(label.color)}
				>
					{label.name}
				</span>
			))}
			{overflow > 0 && (
				<span className="label-chip label-chip-overflow">+{overflow}</span>
			)}
		</div>
	)
}
